import {Injectable} from '@angular/core';
import {GalleryService} from './state/service';
import {GalleryQuery} from './state/query';
import {FilterService as BaseService} from '../../components/filter.service';
import {Gallery} from './state/model';
import {GalleryState, Store} from './state/store';


@Injectable({providedIn: 'root'})
export class FilterService extends BaseService<Gallery, GalleryState, GalleryQuery, Store> {
  constructor(protected query: GalleryQuery, protected api: GalleryService) {
    super(query, api);
  }
}
